module.exports = __webpack_public_path__ + "img/verysatisfied_green.4c8d9578.png";